import React, { useEffect, useState } from "react";

// utils
import "../styles/inbox.css";
import { useNavigate } from "react-router-dom";

// assets
import { images } from "../../../assets/images/index";

// hooks
import { useSelect } from "hooks/useSelect";

// API
import {
  inboxListCounts,
  inboxTeamMembers,
  whatsappBusinessNumbers,
  inboxTags,
  addPinnedTags,
  removePinnedTags,
} from "../api/Api";

import { InboxCampaignList, InboxCampaignExecutions } from "../../../api/apiClients/campaign";

// hooks
import useToggle from "hooks/useToggle";

// redux
import { useAspSelector } from "../../../test/jest-redux-hooks";

// components
import SideBar from "../components/sidebar";
import Conversation from "../components/conversation/index";
import NoData from "../../../components/commonComponents/Nodata/index";
import { Tooltip } from "antd";
import { useDispatch } from "react-redux";
import { updateToggleToast } from "../../../reduxToolkit/appSlice";
import { conversationTypes } from "../../../constant/app/inbox/Inbox";
// import { updateToggleToast } from "../../../../reduxToolkit/appSlice";


const Inbox = () => {
  const { currentBrand, currentAccount, toggleToast } = useAspSelector(
    (state) => state?.app
  );

  const navigate = useNavigate();

  // loading
  const [numberListLoading, setNumberListLoading] = useToggle(false);
  const [teamsLoading, setTeamsLoading] = useToggle(false);
  const [campaignsLoading, setCampaignsLoading] = useToggle(false);
  const [conversationListLoading, setConversationListLoading] =
    useToggle(false);
  const [activeTabName, setActiveTabName] = useState("All Conversations");
  const [activeTabItem, setActiveTabItem] = useState("");
  const [selectedConversationType, setSelectedConversationType] =
    useSelect(null);

  // phone numbers list
  const [numbersList, setNumbersList] = useState(null);
  const [selectedPhoneNumber, setSelectedPhoneNumber] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [listCounts, setListCounts] = useState(null);
  
  // Campaigns
  const [campaigns, setCampaigns] = useState([]);
  const [campaignsClick, setCampaignsClick] = useState(false);

  // Team members
  const [teamMembers, setTeamMembers] = useState(null);
  const [teamMembersClick, setTeamMembersClick] = useState(false);

  // Tag List
  const [tagList, setTagList] = useState([]);
  const dispatch = useDispatch();

  // Campaign Executions
  const [campaignExecutions, setCampaignExecutions] = useState([]);
  const [showCampaignExecutions, setShowCampaignExecutions] = useState(false);
  const [campaignExecutionsLoading, setCampaignExecutionsLoading] = useState(false);

  const inboxCounts = () => {
    const brandId = currentBrand?.brand_id;

    const payLoad = {
      brand_id: brandId,
    };

    if (brandId) {
      inboxListCounts(payLoad?.brand_id).then((res) => {
        if (res && res?.status === 200) {
          setListCounts(res?.data);
        }
      });
    }
  };

  useEffect(() => {
    const intervel = setInterval(() => {
      inboxCounts(currentBrand?.brand_id);
    }, [4000]);

    return () => clearInterval(intervel);
  }, [currentBrand]);

  useEffect(() => {
    fetchWhatsappBusinessNumbers(currentBrand?.brand_id);
    fetchTeamMembers(currentBrand?.brand_id);
    fetchCampaigns(currentBrand?.brand_id);
    fetchTagList(currentBrand?.brand_id);
    setSelectedConversationType(conversationTypes);
  }, []);

  const handleSelect = (item) => setSelectedPhoneNumber(item);

  // fetch whatsapp business numbers
  const fetchWhatsappBusinessNumbers = (brandId) => {
    if (brandId) {
      setNumberListLoading(true);

      whatsappBusinessNumbers(brandId)
        .then((res) => {
          res && res.data?.wapp_business_num?.length > 0
            ? setNumbersList(res?.data?.wapp_business_num)
            : setNumbersList([]);
        })
        .finally(() => {
          setNumberListLoading(false);
        });
    } else {
      setNumbersList([]);
    }
  };

  const defaultConversationType = () => {
    if (!conversationTypes) return;

    const updatedOptions = conversationTypes?.map((o) => {
      if (o?.type === "open") return { ...o, isSelected: true };
      return { ...o, isSelected: false };
    });
    setSelectedConversationType(updatedOptions);
  }

  const fetchTagList = () => {
    const brandId = currentBrand.brand_id;
    if (brandId) {
      // setTeamsLoading(true);  
      inboxTags(brandId)
        .then((res) => {
          if (res?.status === 200) {
            setTagList(res?.data?.user_pin_tags);
            // setTeamsLoading(false);
          }
        })
        .finally(() => {
          // setTeamsLoading(false);
        });
    } else {
      setTagList([]);
    }
  };

  const addTag = (id) => {
      const payLoad = {
        brand_id: currentBrand?.brand_id,
        pinned: true,
        tag_id: id,
      };
      addPinnedTags(payLoad)
          .then((res) => {
            if (res?.status === 200) {
              fetchTagList();
              dispatch(
                updateToggleToast([
                  ...toggleToast,
                  {
                    id: toggleToast?.length + 1,
                    content: "Tag is pinned successfully",
                    status: "Success",
                    duration: "",
                  },
                ])
            );
            }
          })
          .finally(() => {
            // setTeamsLoading(false);
          });
    };
  
    const removeTag = (id) => {
      const payLoad = {
        brand_id: currentBrand?.brand_id,
        pinned: false,
        tag_id: id,
      };
      
      removePinnedTags(payLoad)
          .then((res) => {
            if (res?.status === 200) {
              fetchTagList(currentBrand?.brand_id);
              dispatch(
                updateToggleToast([
                  ...toggleToast,
                  {
                    id: toggleToast?.length + 1,
                    content: "Tag is unpinned successfully",
                    status: "Success",
                    duration: "",
                  },
                ])
            );
            }
          })
          .finally(() => {
            // setTeamsLoading(false);
          });
   
    };
  

  const handleClick = () => {
    setSelectedRole(numbersList);
  };

  if (!numberListLoading && numbersList?.length === 0)
    return (
      <div className="w-full h-full flex-center flex-col">
        <NoData
          icon={images?.noData}
          title="No whatsapp numbers found."
          content={
            <>
              You have not connected any account yet,
              <br /> click on the button to get started.
            </>
          }
          rootClassName="h-auto"
          iconStyle={"w-[8vw]"}
          style={"max-w-[20vw]"}
        />

        {currentAccount?.role !== "Campaigns Manager" ? (
          <button
            className="bg-[var(--new-primary)] text-[var(--white)] font16px-500 px-[0.85vw] py-[0.5vw] rounded-[0.6vw] mt-[0.8vw]"
            onClick={() => {
              navigate("/user/channels/whatsapp");
            }}
          >
            Connect WhatsApp
          </button>
        ) : (
          <Tooltip title={"You are not allowed to perform this action"}>
            <span className="disable-button cursor-not-allowed mt-10">
              Connect WhatsApp
            </span>
          </Tooltip>
        )}
      </div>
    );

  const fetchTeamMembers = (brandId) => {
    if (brandId) {
      setTeamsLoading(true);

      inboxTeamMembers(brandId)
        .then((res) => {
          if (res?.status === 200) {
            setTeamMembers(res?.data?.users);
            setTeamsLoading(false);
          }
        })
        .finally(() => {
          setTeamsLoading(false);
        });
    } else {
      setTeamMembers([]);
    }
  };

  const fetchCampaigns = (brandId) => {
    if (brandId) {
      setCampaignsLoading(true);

      InboxCampaignList(brandId)
        .then((res) => {
          if (res?.status === 200) {
            setCampaigns(res?.data?.campaigns);
          }
        })
        .finally(() => {
          setCampaignsLoading(false);
        });
    } else {
      setCampaigns([]);
    }
  };

  const fetchCampaignExecutions = (brandId, campaignId) => {
    setCampaignExecutionsLoading(true);
    if (brandId && campaignId) {
      InboxCampaignExecutions(brandId, campaignId)
        .then((res) => {
          if (res?.status === 200) {
            setCampaignExecutions(res?.data?.execution_list);
          }
        })
        .finally(() => {
          setCampaignExecutionsLoading(false);
        });
    } else {
      setCampaignExecutions([]);
    }
  };

  return (
    <div className="flex-row w-full h-full">
      <>
        <SideBar
          loading={numberListLoading}
          teamsLoading={teamsLoading}
          list={numbersList}
          teamMembers={teamMembers}
          selectedPhoneNumber={selectedPhoneNumber}
          handleSelect={handleSelect}
          className=""
          selectedRole={selectedRole}
          setSelectedRole={setSelectedRole}
          handleClickNumbers={handleClick}
          activeTabName={activeTabName}
          setActiveTabName={setActiveTabName}
          defaultConversationType={defaultConversationType}
          setActiveTabItem={setActiveTabItem}
          listCounts={listCounts}
          setTeamMembersClick={setTeamMembersClick}
          teamMembersClick={teamMembersClick}
          campaigns={campaigns}
          campaignsLoading={campaignsLoading}
          campaignsClick={campaignsClick}
          setCampaignsClick={setCampaignsClick}
          fetchCampaignExecutions={fetchCampaignExecutions}
          setShowCampaignExecutions={setShowCampaignExecutions}
          tagList={tagList}
          addTag={addTag}
          removeTag={removeTag}
          />

        <div className="flex-1 h-full">
          <div className="w-full h-full bg-[var(--white)]">
            <Conversation
              primaryLoading={numberListLoading}
              loading={conversationListLoading}
              setNumberListLoading={setNumberListLoading}
              setLoading={setConversationListLoading}
              selectedPhoneNumber={selectedPhoneNumber}
              activeTabName={activeTabName}
              activeTabItem={activeTabItem}
              selectedConversationType={selectedConversationType}
              setSelectedConversationType={setSelectedConversationType}
              teamMembers={teamMembers}
              teamMembersClick={teamMembersClick}
              campaigns={campaigns}
              campaignsLoading={campaignsLoading}
              campaignExecutions={campaignExecutions}
              campaignExecutionsLoading={campaignExecutionsLoading}
              showCampaignExecutions={showCampaignExecutions}
            />
          </div>
        </div>
      </>
    </div>
  );
};

export default Inbox;
